import { Ruleset } from "@shared/types";

import { authGet } from "../auth";

export const fetchRulesetWithDefinitions = (id: string) =>
  authGet<Ruleset>(`/api/registry/rulesets/${id}?definition=1&test_cases=1`);
